require([
  //load root dependencies from here
  "jquery",
  "lib/leaflet/dist/leaflet-src.js",
  "lib/esri-leaflet/src/EsriLeaflet.js",
    "lib/esri-leaflet/src/Request.js",
      "lib/esri-leaflet/src/Util.js",
      "lib/esri-leaflet/src/Layers/TiledMapLayer",
      "lib/esri-leaflet/src/Layers/BasemapLayer",
      "lib/esri-leaflet/src/Controls/Logo.js",
  "counties.js",
  "cityinfo.js"
 
], function() {
  // Code kicks off here
});

var map = L.map('map', {minZoom:6, maxZoom:16}).setView([47.280015, -122.314855], 7);

function style(feature) { 
   return {
    weight:2,
    opacity: 1,
    color: 'white',
    fillOpacity: 0,
    fillColor:'white'}
}

function pointstyle(feature) { 
   return {
     radius: radiusSize(feature.properties.total_rev),
    fillColor: "#536879",
    color: "#fff",
    weight: 1,
    opacity: 1,
    fillOpacity: 0.8}
}


function highlightFeature(e) {
  var layer = e.target;
  layer.setStyle({
    weight: 3,
    color: '#ffffff',
    dashArray: '',
    fillOpacity: 0.5
  });
}

var geojson;

function resetHighlight(e) {
 geopoints.resetStyle(e.target);
}

function zoomToFeature(e) {
  var zoomlevel = map.getZoom();
  map.fitBounds(e.target.getBounds(),{minZoom:zoomlevel, maxZoom:zoomlevel} );
}


function onEachFeature(feature, layer) {
 layer.bindPopup('<div class="mediumheader" style=" font-size:18px; padding:8px 8px 0px 8px">' + feature.properties.city + '</div><p style="margin:5px;"><div line-height:2.4">Total revenue: </div><div class="mediumheader" style="padding:0 5px 0 5px; color:#536879">$' + feature.properties.total_rev.toLocaleString() + '</div></p><p style="margin:5px;"><div  line-height:2.4">Total taxes: </div><div class="mediumheader" style="padding:0 5px 0 5px;color:#536879 ">$' + feature.properties.taxes.toLocaleString() + '</div></p><hr><div><div class="lilheader" style="padding-top:0">TOTAL REVENUE PER STORE</div>' + feature.properties.store1 + '</div>');
 layer.on({
  mouseover: highlightFeature,
  mouseout: resetHighlight,
  click:zoomToFeature
});

 return {
    weight: 1,
    opacity: 0.7,
    color: 'white',
    fillOpacity: 0.7}
}

 geojson = L.geoJson(counties, {
      style: style,
    }).addTo(map);

L.esri.basemapLayer('Gray').addTo(map);

 function radiusSize(d) {
   return d >= 2000000 ? '30' :
   d >= 1500000  ? '25' :
    d >= 1000000  ? '20' :
     d >= 500000  ? '15' :
   d >= 100000   ? '10' :
   d > 0   ? '5' :
   '1'
 }

 map.fitBounds(geojson.getBounds());

var geojsonMarkerOptions = {
};

var geopoints; 

geopoints = L.geoJson(cityinfo, {
	style: pointstyle,
	onEachFeature: onEachFeature,
    pointToLayer: function (feature, latlng) {
        return L.circleMarker(latlng, geojsonMarkerOptions);}
}).addTo(map);


map.on('zoomend', function() {
   map.removeLayer(geopoints);
   geopoints = L.geoJson(cityinfo, {
  style: pointstyle,
  onEachFeature: onEachFeature,
    pointToLayer: function (feature, latlng) {
        return L.circleMarker(latlng, geojsonMarkerOptions); }
}).addTo(map);

});




define("main", function(){});

